/**
* Adopt Feed JS
* -----------------------------------------------------------------------------
*
* All the JS for the Adopt Feed component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'adopt-feed',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      function checkHash() {
        if ( window.location.hash.includes( 'sl_embed' ) ) {
          const adoptFeedID = $( '.adopt-feed' ).get( 0 );
          if ( adoptFeedID ) {
            const top = getCoords( adoptFeedID ).top;
            window.scrollTo( {top: top, behavior: 'instant'} );
          }
        }
      }

      // Trigger on initial load
      checkHash();


      function getCoords( elem ) { // crossbrowser version
        const box = elem.getBoundingClientRect();

        const body = document.body;
        const docEl = document.documentElement;

        const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        const clientTop = docEl.clientTop || body.clientTop || 0;
        const clientLeft = docEl.clientLeft || body.clientLeft || 0;

        const top = box.top + scrollTop - clientTop;
        const left = box.left + scrollLeft - clientLeft;

        return {top: Math.round( top ), left: Math.round( left )};
      }


      function watchShelterluvIframe( containerId ) {
        const container = document.getElementById( containerId );

        const observer = new MutationObserver( ( mutations ) => {
          mutations.forEach( ( mutation ) => {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'src' &&
              mutation.target.tagName === 'IFRAME'
            ) {
              // When iframe finishes loading that new URL
              mutation.target.addEventListener( 'load', function onLoad() {
                const adoptFeedID = $( '.adopt-feed' ).get( 0 );
                if ( adoptFeedID ) {
                  const top = getCoords( adoptFeedID ).top;
                  const bodyPaddingTop = parseInt( $( 'body' ).css( 'padding-top' ), 10 );
                  window.scrollTo( {top: ( top - bodyPaddingTop ), behavior: 'instant'} );
                }
                mutation.target.removeEventListener( 'load', onLoad );
              } );
            }
          } );
        } );

        observer.observe( container, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['src'],
        } );
      }

      // Usage after you embed pets
      const frameWrapper = $( 'div[id^="shelterluv_wrap_"]' );
      if ( frameWrapper.length ) {
        watchShelterluvIframe( frameWrapper.first().attr( 'id' ) );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'adopt-feed', COMPONENT );
} )( app );
